// extracted by mini-css-extract-plugin
export default {"categoriesForm":"MessagesTemplate_categoriesForm__zKrl8"};